import { DataInitialize } from '../DataInitialize';
import { DataCallback } from '../DataCallback';

export class FirestoreCollection implements DataInitialize {
  public constructor(public readonly collection: any) {
  }

  public async getAll(callback: DataCallback): Promise<boolean> {
    const self = this;
    const d = new Date();
    await this.collection
      .get()
      .then(async (snapShot: any) => {
        const promises:Promise<boolean>[] = [];
        const result = await snapShot.forEach(async (doc: any) => {
          //console.log(this, 'getAll')
          promises.push(callback.setData(doc.id, doc.data()));
          return true;
        });

        return Promise.all(promises);;
      })
      .catch(async (error: Error) => {
        return await callback.setData(error.message, {});
      });
    return true;
  }

  public waitSnapshot(callback: DataCallback, lastUpdate: any): void {
    const self = this;
    this.collection
      .where('timestamp', '>', lastUpdate)
      .onSnapshot((querySnapshot: any) => {
        querySnapshot.docChanges().forEach((change: any) => {
          callback.setData(change.doc.id, change.doc.data())
        })
      })
  }

  public save(data: any) {
    this.collection.add(data);
  }
}
